import { useEffect, useState } from 'react'

/**
 * Custom hook to detect if the browser supports the inert attribute
 * @returns boolean indicating if inert is supported
 */
export const useInertSupport = (): boolean => {
  const [supportsInert, setSupportsInert] = useState(false)

  useEffect(() => {
    const testElement = document.createElement('div')
    testElement.setAttribute('inert', '')
    const hasInert = testElement.hasAttribute('inert')
    setSupportsInert(hasInert)
  }, [])

  return supportsInert
}
